export class CarouselItem extends HTMLElement {
  connectedCallback() {
    this.classList.add('glide__slide');
  }

  disconnectedCallback() {
    this.classList.add('glide__slide');
  }
}